import React from 'react';
import {translate} from 'react-i18next';

import {Row, Column} from '../../global/grid/grid';
import { H1 } from '../../global/typography/typography';
import Image from '../../global/media/Image';

import { Tile, Content, ContentWrapper, Title, ImageRow, ColorBlock, CardHolder } from './styled-components';


const CampaignSumamry = ({data, imageDictionary, t}) => {
  return (
    <div>
        <Row style={{position: 'relative'}}>
            <Column cw={11} offset={1}>
                <div style={{width: '100%', position: 'relative'}}>
                    <ColorBlock />
                    <Image aspectWidth={5} aspectHeight={2} sizes={imageDictionary[data.image].sizes} />
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1,
                        background: 'white',
                        opacity: 0.5
                    }}></div>
                </div>
            </Column>
            <CardHolder>
                <Row margins={false} style={{position: 'relative', marginBottom: '300px'}}>
                    <Column cw={3} style={{position: 'relative'}}>
                        <Tile style={{marginTop: '60%'}}>
                            <ContentWrapper>
                                <Content>
                                    <div className="label">{t('campaignSummary.tile1.label')}</div>
                                    <div className="dataPoint">{t('campaignSummary.tile1.dataPoint')}</div>
                                </Content>
                            </ContentWrapper>
                        </Tile>
                    </Column>
                    <Column cw={3}>
                        <Tile style={{marginTop: '40%'}}>
                            <ContentWrapper>
                                <Content>
                                    <div className="label">{t('campaignSummary.tile2.label')}</div>
                                    <div className="dataPoint">{t('campaignSummary.tile2.dataPoint')}</div>
                                </Content>
                            </ContentWrapper>
                        </Tile>
                    </Column>
                    <Column cw={3}>
                        <Tile style={{marginTop: '20%'}}>
                            <ContentWrapper>
                                <Content>
                                    <div className="label">{t('campaignSummary.tile3.label')}</div>
                                    <div className="dataPoint">{t('campaignSummary.tile3.dataPoint')}</div>
                                </Content>
                            </ContentWrapper>
                        </Tile>
                    </Column>
                    <Column cw={3}>
                        <Tile style={{marginTop: '0%'}}>
                            <ContentWrapper>
                                <Content>
                                    <div className="label">{t('campaignSummary.tile4.label')}</div>
                                    <div className="dataPoint">{t('campaignSummary.tile4.dataPoint')}</div>
                                </Content>
                            </ContentWrapper>
                        </Tile>
                    </Column>
                </Row>
            </CardHolder>
        </Row>
    </div>
  )
}

export default translate()(CampaignSumamry);



// WEBPACK FOOTER //
// ./src/components/modules/CampaignSummary/CampaignSummary.js